export default {
    SET_REPEAT_VISIBILITY: 'SET_REPEAT_VISIBILITY',
};
